<div class="person-explorer-engagements-part">
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="personExplorer.explorer.customGridHeight()" [rows]="engagements()"></grid-content>
</div>